
export enum AuthErrorMessageEnum {
  "auth/email-already-in-use" = "Email has already been signed up. Have you forgot your password?",
  "auth/email-not-verified" = "Account not activated. An link to activate your account has been sent to your email.",
  "auth/invalid-email" = "Please provide a valid email.",
  "auth/multiple-accounts" = "You have already signed up with a different auth provider for that email.",
  "auth/no-current-user" = "Signed out successfully!",
  "auth/sign-in-error" = "An Error Occurred while signing. Please sign in again. Sorry for the inconvenience",
  "auth/user-not-found" = "You have not registerd yet! Please Sign Up.",
  "auth/user-disabled" = "Account has been disabled",
  "auth/weak-password" = "Weak password. Please choose a strong password",
  "auth/wrong-user-pass" = "Wrong Username or password.",
}

export enum LinksEnum {
  account = "/account",
  cancellationPolicy = "/cancellation-policy",
  home = "/",
  login = "/login",
  ownerAgreement = "/owner-agreement",
  parkingServiceAgreement = "/parking-service-agreement",
  privacyPolicy = "/privacy-policy",
  rentSpace = "/rent-your-space",
  terms = "/terms-and-conditions",
  trackCar = "/track-my-car/:orderUid",
  trackCarHome = "/track-my-car",
  userAgreement = "/user-agreement",
  gobumprCampaign = "/GoBumprOffers",
  goBumprCampaignOffer = "/GoBumprOffers/:package"
}

export enum SaveStatusEnum {
  error = "Failure",
  none = "None",
  success = "Success",
}

export enum StatusEnum {
  Active = "Active",
  Cancelled = "Cancelled",
  Completed = "Completed",
  Rejected = "Rejected"
}

export enum StatusCodeEnum {
  ERROR = "ERROR",
  INVDAT = "INVDAT",
  SUCCESS = "SUCCESS",
  UNAUTHNUM = "403",
  UNAUTHTXT = "Unauthorized"
}

export enum StatusCodeMessageEnum {
  ERROR = "Exception thrown",
  INVDAT = "Invalid data",
  SUCCESS = "Success",
  UNAUTHORIZED = "Session Expired. Plese login again"
}

export enum TaskStatusEnum {
  DropOffCompleted = "DropOffCompleted",
  DropOffDriverAssigned = "DropOffDriverAssigned",
  DropOffDriverConfirm = "DropOffDriverConfirm",
  DropOffSelfTag = "DropOffSelfTag",
  DropOffTag = "DropOffTag",
  DropOffUserConfirm = "DropOffUserConfirm",
  Paid = "Paid",
  ParkingAlloted = "ParkingAlloted",
  Parked = "Parked",
  ParkingComplete = "ParkingComplete",
  ReturnCompleted = "ReturnCompleted",
  ReturnDriverAssigned = "ReturnDriverAssigned",
  ReturnDriverConfirm = "ReturnDriverConfirm",
  ReturnStarted = "ReturnStarted",
  ReturnUserConfirm = "ReturnUserConfirm",
}

export enum TaskEnum {
  DropOff = "DropOff",
  Parking = "Parking",
  Return = "Return",
}
